// whitelist where this is allowed to load

((window) => {
  if(
     window.location.hostname !== 'www.generalatlantic.com'
     && window.location.hostname !== 'generalatlantic.com'
     && window.location.hostname !== 'generalatlantic.test'
     && window.location.hostname !== 'general-atlantic.test'
     && !window.location.hostname.includes('localhost')
     && !window.location.hostname.includes('general-atlantic.pantheonsite.io')
    ) {
      window.location.replace('https://google.com');
  }
})(window);

jQuery( document ).ready(function($) {

  $(".dkpdf-button").html("<span>PDF: </span><i class='far fa-file-pdf'></i>");

  var winWidth = $(window).width();

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return false;
  }

  $('.grid-items').on('click', '.grid-item', function() {

    if ( !$(this).hasClass('media-item') ) {

      $('.grid-item').removeClass('is-expanded');
      $(this).addClass('is-expanded');

      var gridOffset = $(this).offset();
      var banner = winWidth > 1199 ? 102 : 80;

      $('html, body').animate({
        scrollTop: gridOffset.top - banner
      }, 750);

    }

  });

  $('.grid-items').on('click', '.grid-item--accordion-close', function(e) {
    e.preventDefault();
    $(this).closest('.grid-item--accordion').prev().removeClass('is-expanded');
  });

  $('.navbar-toggler').on('click', function(e) {
    e.preventDefault();
    $('body').toggleClass('menu-is-open');
  });

  if ( $('body').hasClass('portfolio') ) {

    var id = getQueryVariable('id');

    if ( id ) {

      var section = $('#' + id);
      section.addClass('is-expanded');
      var sectionOffset = section.offset();
      var banner = winWidth > 1199 ? 155 : 80;

      $('html, body').animate({
        scrollTop: sectionOffset.top - banner
      }, 750);

    }

  }

  if ( $('body').hasClass('about-us') ) {

    $("a[href*='#']").not('.ga-back').on('click',function(e) {

      e.preventDefault();

      var url = $(this).attr('href');
      var url_split = url.split('#');
      url = url_split[1];

      if (url) {

        $('body').removeClass('menu-is-open');

        var section = $('#' + url);
        var sectionOffset = section.offset();
        var banner = winWidth > 1199 ? 155 : 80;

        e.preventDefault();
        $('html, body').animate({
          scrollTop: sectionOffset.top - banner
        }, 750);

      }

    });

  }

  $('.back-to-top').on('click', function(e) {

    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 750);

  });

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode ? 'is-ie' : 'is-not-ie';

  $('body').addClass('is-loaded').addClass(isIE11);

  // Detect if banner has been scrolled past
  var navScrolled = function() {

    var $window    = $(window);
    var docViewTop = 90;
    var nav        = $('.banner');
    var elemTop    = $window.scrollTop();

    if ( elemTop > docViewTop ) {
      nav.addClass('scrolled');
    } else {
      nav.removeClass('scrolled');
    }

  };

  navScrolled();

  $( window ).scroll( function(e) {
    navScrolled();
  });

  // Detect if element is inview
  var inView = function ( elements ) {

    var $window    = $(window);
    var docViewTop = $window.scrollTop() + $window.height() - ( $window.height() / 10 );

    elements.each( function( index ) {

      if ( !$(this).hasClass('over') ) {

        var elemTop = $(this).offset().top;

        if ( elemTop < docViewTop ) {
          $(this).addClass('over');
        }

      }

    });

  };

  inView( $('.inview') );

  $( window ).scroll( function(e) {
    inView( $('.inview') );
  });

  if ( $('.blank').length > 0 ) {

    $('.blank').each( function(index, value) {
      $(this).find('a').attr('target','_blank').attr('rel','external noreferrer noopener');
    });

  }

});
